<div class="container" [class.container-fluid]="isFluid()" [class.container-fixed]="isFixed()">
    <ng-content></ng-content>
</div>
